export const XIcon = ({ width = '14', height = '14' }): JSX.Element => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    fill="none"
    viewBox="0 0 14 14"
  >
    <path
      stroke="#868C98"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M13 1 1 13M1 1l12 12"
    />
  </svg>
);
